import e from "lodash/once";
function t(e) {
  return t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, t(e);
}
function r(e) {
  return function (e) {
    if (Array.isArray(e)) return n(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return n(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === r && e.constructor && (r = e.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(e);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return n(e, t);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function n(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function o(e) {
  return null != e && e.nodeType === Node.ELEMENT_NODE;
}
var a = Object.freeze({
    __proto__: null,
    element: o,
    button: function (e) {
      return o(e) && "button" === e.tagName.toLowerCase();
    },
    input: function (e) {
      return o(e) && "input" === e.tagName.toLowerCase();
    },
    array: function (e) {
      return null != e && e instanceof Array;
    }
  }),
  i = function (e) {
    var t,
      r,
      n = (null !== (t = null === (r = l.get(e)) || void 0 === r ? void 0 : r.length) && void 0 !== t ? t : 0).toString().padStart(4, "0");
    return "lg-ui".concat(e ? "-".concat(e) : "", "-").concat(n);
  },
  l = new Map(),
  c = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
      t = i(e);
    if (l.has(e)) {
      var n = l.get(e);
      l.set(e, [t].concat(r(n)));
    } else l.set(e, [t]);
    return t;
  };
function u(e) {
  return "string" == typeof (r = e) || "number" == typeof r ? e.toString().trim() : Array.isArray(e) ? e.map(u).join(" ").trim() : function (e) {
    return e && "object" === t(e) && e.props;
  }(e) ? u(e.props.children) : "";
  var r;
}
var f = {
    Light: "light",
    Dark: "dark"
  },
  p = function (e) {
    return e ? f.Dark : f.Light;
  },
  s = {
    darkMode: {
      description: "Render the component in dark mode.",
      control: "boolean"
    },
    ref: {
      description: "`ref` passed to the component",
      control: "none"
    },
    onClick: {
      description: "Function to handle a click event.",
      control: "none"
    },
    children: {
      description: "Element rendered inside the component",
      control: "text"
    },
    as: {
      description: "The component will be rendered in HTML as the element selected here",
      options: ["symbol", "object", "small", "button", "a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noindex", "noscript", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "slot", "script", "section", "select", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "template", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "webview", "svg", "animate", "animateMotion", "animateTransform", "circle", "clipPath", "defs", "desc", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "switch", "text", "textPath", "tspan", "use", "view"],
      type: {
        name: "string"
      },
      control: {
        type: "select"
      }
    }
  };
function d(e, r) {
  return null != e && "object" === t(e) && "type" in e && e.type.displayName === r;
}
function m(e) {
  var t,
    r,
    n,
    o = "data-leafygreen-ui";
  return {
    prop: (t = {}, r = o, n = e, r in t ? Object.defineProperty(t, r, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[r] = n, t),
    selector: "[".concat(o, '="').concat(e, '"]')
  };
}
var g = {
    ArrowUp: 38,
    ArrowDown: 40,
    ArrowLeft: 37,
    ArrowRight: 39,
    Backspace: 8,
    BracketLeft: 91,
    Delete: 46,
    Enter: 13,
    Escape: 27,
    Space: 32,
    Tab: 9
  },
  b = {
    Page: "page",
    Step: "step",
    Location: "location",
    Date: "date",
    Time: "time",
    True: "true",
    Unset: "false"
  };
function y(e) {
  throw Error("Received unhandled value: ".concat(e));
}
var h = {
  error: e(console.error),
  warn: e(console.warn),
  log: e(console.log)
};
export { b as AriaCurrentValue, f as Theme, h as consoleOnce, m as createDataProp, c as createUniqueClassName, y as enforceExhaustive, u as getNodeTextContent, p as getTheme, d as isComponentType, g as keyMap, s as storybookArgTypes, a as typeIs };